import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	users: [],
};

const usersSlice = createSlice({
	name: 'users',
	initialState: initialState,
	reducers: {
		setUsers: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setUsers, reset } = usersSlice.actions;

export default usersSlice.reducer;
